import {
  Wifi, Car, Drop, Building, ShieldTick, Coffee, Pet,
  Monitor, Health, Teacher, Airplane, Lamp, Book, Briefcase,
  Camera, Key, Lock, Map1, Musicnote, Sun1, Clock, Award,
  Video, VolumeHigh, Wallet, Watch, Tree, Flash, Activity,
  Ruler, GasStation, Home, Heart, Star1, People, Trash,
  Gps, Gallery, Play, Call, Sms, Global, Discover,
  Setting4, TickCircle, InfoCircle, Notification, Category,
  SmartCar, Hospital, Bus, Ship, Microphone, Headphone,
  Add, AddCircle, ArrowLeft, ArrowLeft2, ArrowDown2, ArrowRight2,
  CloseCircle, DocumentText, Edit2, More, Eye, EmojiHappy,
  Location, ExportSquare, Send2, Profile, SearchNormal1,
  Share, Message, Chart, Brush2, Crown, Cloud,
} from 'iconsax-reactjs';

const FACILITY_ICONS = [
  { name: 'Wifi', label: 'WiFi', component: Wifi },
  { name: 'Car', label: 'Parking', component: Car },
  { name: 'SmartCar', label: 'EV Charging', component: SmartCar },
  { name: 'Drop', label: 'Water / Pool', component: Drop },
  { name: 'Building', label: 'Building', component: Building },
  { name: 'ShieldTick', label: 'Security', component: ShieldTick },
  { name: 'Coffee', label: 'Cafe', component: Coffee },
  { name: 'Pet', label: 'Pet Friendly', component: Pet },
  { name: 'Monitor', label: 'TV / Display', component: Monitor },
  { name: 'Health', label: 'Health / Gym', component: Health },
  { name: 'Activity', label: 'Fitness', component: Activity },
  { name: 'Hospital', label: 'Medical', component: Hospital },
  { name: 'Teacher', label: 'School / Education', component: Teacher },
  { name: 'Book', label: 'Library', component: Book },
  { name: 'Airplane', label: 'Airport', component: Airplane },
  { name: 'Bus', label: 'Bus / Transit', component: Bus },
  { name: 'Lamp', label: 'Bedroom / Lighting', component: Lamp },
  { name: 'Briefcase', label: 'Business', component: Briefcase },
  { name: 'Camera', label: 'CCTV / Camera', component: Camera },
  { name: 'Key', label: 'Key / Access', component: Key },
  { name: 'Lock', label: 'Gated Access', component: Lock },
  { name: 'Map1', label: 'Map', component: Map1 },
  { name: 'Musicnote', label: 'Music', component: Musicnote },
  { name: 'Sun1', label: 'Sunny / Terrace', component: Sun1 },
  { name: 'Cloud', label: 'Cloud / AC', component: Cloud },
  { name: 'Clock', label: '24-Hour', component: Clock },
  { name: 'Award', label: 'Premium', component: Award },
  { name: 'Crown', label: 'Luxury', component: Crown },
  { name: 'Video', label: 'Surveillance', component: Video },
  { name: 'VolumeHigh', label: 'Sound / Audio', component: VolumeHigh },
  { name: 'Wallet', label: 'Payment', component: Wallet },
  { name: 'Watch', label: 'Schedule', component: Watch },
  { name: 'Tree', label: 'Garden / Park', component: Tree },
  { name: 'Flash', label: 'Power Backup', component: Flash },
  { name: 'Ruler', label: 'Measurement', component: Ruler },
  { name: 'GasStation', label: 'Gas Station', component: GasStation },
  { name: 'Home', label: 'Home', component: Home },
  { name: 'Gallery', label: 'Gallery', component: Gallery },
  { name: 'Play', label: 'Entertainment', component: Play },
  { name: 'People', label: 'Community', component: People },
  { name: 'Trash', label: 'Waste Mgmt', component: Trash },
  { name: 'Star1', label: 'Rating / Star', component: Star1 },
  { name: 'Gps', label: 'GPS / Location', component: Gps },
  { name: 'Global', label: 'Internet', component: Global },
  { name: 'Brush2', label: 'Painting / Decor', component: Brush2 },
  { name: 'Headphone', label: 'Intercom', component: Headphone },
  { name: 'Ship', label: 'Waterfront', component: Ship },
  { name: 'Discover', label: 'Explore', component: Discover },
];

const iconComponentMap = {};
FACILITY_ICONS.forEach(({ name, component }) => {
  iconComponentMap[name] = component;
});

// Backward compatibility: old Ionicons names → iconsax components
const legacyMap = {
  'wifi': Wifi,
  'car': Car,
  'water': Drop,
  'business': Building,
  'shield-checkmark': ShieldTick,
  'cafe': Coffee,
  'paw': Pet,
  'desktop': Monitor,
  'fitness': Health,
  'medical': Hospital,
  'school': Teacher,
  'airplane': Airplane,
  'bed': Lamp,
  'book': Book,
  'briefcase': Briefcase,
  'camera': Camera,
  'key': Key,
  'lock-closed': Lock,
  'map': Map1,
  'musical-notes': Musicnote,
  'partly-sunny': Sun1,
  'time': Clock,
  'trophy': Award,
  'tv': Monitor,
  'videocam': Video,
  'volume-high': VolumeHigh,
  'wallet': Wallet,
  'watch': Watch,
  'trash': Trash,
  'flash': Flash,
  'earth': Global,
  'leaf': Tree,
  'snow': Cloud,
  'home': Home,
  'heart': Heart,
  'star': Star1,
  'location': Location,
  'search': SearchNormal1,
  'call': Call,
  'mail': Sms,
  'send': Send2,
  'eye': Eye,
  'checkmark-circle': TickCircle,
  'close': CloseCircle,
  'person': Profile,
  'people': People,
  'notifications': Notification,
  'settings': Setting4,
  'pencil': Edit2,
  'add': Add,
};

export function getIconComponent(name) {
  return iconComponentMap[name] || legacyMap[name] || InfoCircle;
}

export { FACILITY_ICONS, iconComponentMap, legacyMap };
